import React from "react";

// import { ReactComponent as PlusInCircle } from "../../../assets/icons/plus-in-circle.svg";
import AddIcon from "@mui/icons-material/Add";
import { DealCreate } from "components/modals";
import { useCanCreateDeal, useNavigate, usePrompt } from "hooks";

import "./AddDealCard.styles.scss";

export const AddDealCard: React.FC = () => {
  const openPrompt = usePrompt();
  const navigate = useNavigate();
  const canCreateDeal = useCanCreateDeal();

  const createDeal = async () => {
    const data = await openPrompt({ Component: DealCreate, props: {} });

    if (!data) return;

    navigate({ route: "deal", params: { deal_id: data.id } });
  };

  if (!canCreateDeal) return null;

  return (
    <div data-testid="create-deal-card" onClick={createDeal} className="add-deal__card add-deal__card-wrapper">
      <div className="add-deal__card-icon">
        <AddIcon sx={{ color: "#0a3142" }} />
      </div>
      <span className="add-deal__start-card-title">Add Deal</span>
    </div>
  );
};
